//Content.js
import React, {Component} from 'react';
import {  Link } from 'react-router-dom';
import axios from 'axios';
// const querystring = require('querystring');

export default class Desktops extends Component {

	constructor(props)
	{
		console.log(props);
		super(props);
		let parms = "";
		//JSON.stringify(querystring.parse(this.props.location.search)).replace('?', '');
        console.log("parms => " + parms);

		this.state = {
			currentUserName : '',
			userId : props.userId,
			userWorkspace : {
			userWorkspaceId : JSON.parse(parms).id,
			workspaceName : '',
			workspaceDescr : '',
			workspacePath : '',
			templateId : 0,
			imageFeedPath : '',
			audioFeedPath : '',
			videoFeedPath : '',
			currentProjectId : 0,
			projectHistoryId : 0,
			lastUpdateUser: props.userId,
			lastUpdateDate : new Date(),			
			workspaceStatusCode : 0,
			pictureFilepath : '',
			cloudName : ''
			},
			createUserName : "teset",
			lastUpdateUserName : ""
		}
		this.updateDesktop = this.updateDesktop.bind(this);
	}
	
	componentDidMount() 
	{
		this.handleOnLoad();
	}
	handleOnLoad() {

		var queryUrl = `${global.config.apiServicesUrl}/user-workspaces/${this.state.userWorkspace.userWorkspaceId}`;
        console.log(queryUrl);
        axios.get(queryUrl)
			.then(response =>{
				this.setState({userWorkspace : response.data});
			}).catch(function (error) {
				console.log("Error:"+error);
		});	
		{
					axios.get(`${global.config.securityServicesUrl}/user-profile-service/userprofile/username/${this.state.userWorkspace.lastUpdateUser}`)
					.then(response =>{
 					this.setState({lastUpdateUserName : response.data});
					console.log("lastupdateuserid " + response.data);
					}).catch(function (error) {
					console.log("Error:"+error);
					});		
		}

	
// 		alert(this.props.location.search);
// 		var processedString = querystring.parse(this.props.location.search.substring(1));
// 		alert(JSON.stringify(processedString));
// 		var id = processedString.id;
// 		var name = processedString.name;
// 		console.log(self.state.currentUserIdentity.id);
//         var queryUrl = '/desktop/' + id;
//         alert(queryUrl);
//         fetch(queryUrl, {
//             method: 'GET'
//         }).then(function(response) {
//             if (response.status >= 400) {
//                 throw new Error("Bad response from server");
//             }
//             return response.json();
//         }).then(function(data1) {
//         	alert(JSON.stringify(data1[0]));
//             this.state.data = data1[0];
//             console.log(data1);
//         }).catch(err => {
//         console.log('caught an exception!',err);
//         })
        //alert(JSON.stringify(self.state.data));	
	}
	updateDesktop(event)
	{
// 		this.state.data.workspace_name = this.state.workspace_name;
// 		this.state.data.workspace_descr = this.state.workspace_descr;
// 		this.state.data.template_id = this.state.template_id;
// 		this.state.data.workspace_status_code = this.state.workspace_status_code;
// 
// 		var queryUrl = '/desktop/update/'+this.state.user_workspace_id;
//         console.log(queryUrl);
// 
//         fetch(queryUrl, {
//             method: 'POST',
//             headers : {
//             	'Accept' : 'application/json',
//             	'Content-Type': 'application/json'
//             },
//             body : JSON.stringify(this.state.data)
//         }).then(function(response) {
//             if (response.status >= 400) {
//                 throw new Error("Bad response from server");
//             }
//         }).then(function(data) {
//             console.log(data);
//         }).catch(err => {
//         	alert(err);        	
//         console.log('caught an exception!',err);
//         })
// 
// 		//var formObject = document.getElementById('updateDesktopForm');
// 		//formObject.reset();
// 		event.preventDefault();
	}
	
    render(){

        return (


			<div class="m-content">				
			<div class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-body">
       				<div class="m-grid__item m-grid__item--fluid m-wrapper">
					<div class="m-subheader ">					
						<div class="d-flex align-items-center">
							<div class="mr-auto">
								<h3 class="m-subheader__title m-subheader__title--separator">Gazelle VLM</h3>
								<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
									<li class="m-nav__item m-nav__item--home">
										<a href="index.html" class="m-nav__link m-nav__link--icon">
											<i class="m-nav__link-icon la la-home"></i>
										</a>
									</li>
									<li class="m-nav__separator">-</li>
									<li class="m-nav__item">
										<a href="index.html" class="m-nav__link">
											<span class="m-nav__link-text">Home</span>
										</a>
									</li>
								</ul>
							</div>
							<div>
								<span class="m-subheader__daterange" id="m_dashboard_daterangepicker">
									<span class="m-subheader__daterange-label">
										<span class="m-subheader__daterange-title"></span>
										<span class="m-subheader__daterange-date m--font-brand"></span>
									</span>
									<a href="index.html" class="btn btn-sm btn-brand m-btn m-btn--icon m-btn--icon-only m-btn--custom m-btn--pill">
										<i class="la la-angle-down"></i>
									</a>
								</span>
							</div>
						</div>
						<br />

					<div className="content-wrapper">
						<div class="m-portlet">
							<br />
													<div class="row">
														<h3 class="col-sm-2 m-widget1__title">
															Workspaces
														</h3>
														&nbsp;
														<input class="form-control input-xlarge col-sm-6" placeholder="Filter" />
														&nbsp;
														<a href="/create-desktop" class="btn btn-success">Create Workspace</a>
													</div>

		<hr />


		<div class="form-group row" >
				<label class="ContentTitle col-sm-2" value="Desktop Name">Desktop Name</label>
				<input id="workspaceName" class="form-control input-medium col-sm-8" value={this.state.userWorkspace.workspaceName}></input>
		</div>
		<div class="form-group row" >
				<label class="ContentTitle col-sm-2" value="Summary">Summary</label>
				<input id="workspaceDescr" class="form-control input-medium col-sm-8" value={this.state.userWorkspace.workspaceDescr}></input>
		</div>
		<div class="form-group row" >
				<label class="ContentTitle col-sm-2" value="Summary">Template</label>
					<select id="templateId" class="form-control input-medium col-sm-8" value={this.state.userWorkspace.templateId} name="templateId">
						<option value="0">Select A Machine Image</option>
						<option value="1">Windows</option>
						<option value="2">Mac</option>
						<option value="3">Linux</option>
						<option value="4">Gazelle Machine</option>
					</select>
		</div>
		<div class="form-group row" >
				<label class="ContentTitle col-sm-2" value="Status">Status</label>
					<select id="workspaceStatusCode" class="form-control input-medium col-sm-8" value={this.state.userWorkspace.workspaceStatusCode}>
						<option value="0">Select Desktop Status</option>
						<option value="719">Active</option>
						<option value="718">Inactive</option>
					</select>
				
		</div>
		<div class="form-group row" >
				<label class="ContentTitle col-sm-2" >Path</label>
				<input id="workspacePath" class="form-control input-medium col-sm-8" value={this.state.userWorkspace.workspacePath}></input>
		</div>
		<div class="form-group row" >
				<label class="ContentTitle col-sm-2" >Image Feed Path</label>
				<input id="imageFeedPath" class="form-control input-medium col-sm-8" value={this.state.userWorkspace.imageFeedPath}></input>
		</div>
		<div class="form-group row" >
				<label class="ContentTitle col-sm-2" >Audio Feed Path</label>
				<input id="audioFeedPath" class="form-control input-medium col-sm-8" value={this.state.userWorkspace.audioFeedPath}></input>
		</div>
		<div class="form-group row" >
				<label class="ContentTitle col-sm-2" >Video Feed Path</label>
				<input id="videoFeedPath" class="form-control input-medium col-sm-8" value={this.state.userWorkspace.videoFeedPath}></input>
		</div>
		<div class="form-group row" >
				<label class="ContentTitle col-sm-2" >Current Project</label>
				<input id="currentProjectId" class="form-control input-medium col-sm-8" value={this.state.userWorkspace.currentProjectId}></input>
		</div>
		<div class="form-group row" >
				<label class="ContentTitle col-sm-2" value="Project History">Project History</label>
				<input id="projectHistoryId" class="form-control input-medium col-sm-8" value={this.state.userWorkspace.projectHistoryId}></input>
		</div>
		<div class="form-group row" >
				<label class="ContentTitle col-sm-2">Image Path</label>
				<input id="pictureFilepath" class="form-control input-medium col-sm-8" value={this.state.userWorkspace.pictureFilepath}></input>
		</div>
		<div class="form-group row" >
				<label class="ContentTitle col-sm-2" >Cloud Name</label>
				<input id="cloudName" class="form-control input-medium col-sm-8" value={this.state.userWorkspace.cloudName}></input>
		</div>
		<hr/>
		<div class="form-group row" >
		<label class="ContentTitle col-sm-2" >Last Updated By</label>
		<input id="lastUpdateUserName" class="form-control input-medium col-sm-2" value={this.state.lastUpdateUserName} />
		<label class="ContentTitle col-sm-1" > On </label>
		<input id="lastUpdateDate" class="form-control input-medium col-sm-2" value={String(this.state.userWorkspace.lastUpdateDate).substring(0,10)} />
		</div>
		<hr />	

			<button type='submit' class="btn btn-success m-btn m-btn--pill m-btn--custom m-btn--icon m-btn--air" value="Create"  >Update</button>&nbsp;
			<button type='reset' class="btn btn-info m-btn m-btn--pill m-btn--custom m-btn--icon m-btn--air" value="Clear" >Clear</button>&nbsp;						
			<button type='submit' class="btn btn-danger m-btn m-btn--pill m-btn--custom m-btn--icon m-btn--air" value="Delete" >Delete</button>	&nbsp;					
			<br />

												</div>

											</div>
						</div>
            </div>
            
			</div>
			</div>
			
			)
		}
	}